// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1Dkzn","actionsCol":"EnrolledClinics_actionsCol__1_nlS"};